<template>
<div>
  <div style="padding:20px;">
    <a href="/" title="Home"><img src="/images/logo.svg" width="246" height="42" alt="" class="header-logo"></a>
  </div>
  <div style="max-width:1320px;margin:auto;padding:10px 20px 0;" v-if="is_loaded">
    <div class="pta-meeting-head">
      <h2>Meeting Minutes</h2>
      <p>{{transcript.title}}</p>
      <ul class="mm-links">
        <li><a :href="'/mm/'+transcript.alias+'/pdf'" class="mm-link-pdf">PDF</a></li>
        <li><a :href="'/mm/'+transcript.alias+'/doc'" class="mm-link-word">Word</a></li>
      </ul>
    </div>
    <div class="pta-meeting-left">
      <div style="background:#E9F8FC;border:1px solid #34A7C2;padding:30px;margin-bottom:30px;border-radius:10px;font-size:16px;line-height:22px;color:#1C2136;">
        Minutes of the meeting held on {{transcript.held_at|momentDateTime}}.<br /><br />
        In attendance:
        <span class="pta-transcript-participant" v-if="transcript.speakers">{{ transcript.speakers }}</span>
        <span class="pta-transcript-participant" v-if="!transcript.speakers" v-for="participant in transcript.participants">{{ participant.name }}</span>
      </div>
      <div style="background:#ffffff;padding:30px;margin-bottom:30px;border-radius:10px;">
        <h3 style="font-weight:600;margin-bottom:30px;">Suggested Meeting Agenda</h3>
        <ul class="pta-meeting-agenda">
          <li><i>1</i>Introduction - Investor</li>
          <li><i>2</i>Introduction - Sponsor</li>
          <li><i>3</i>Presentation - Sponsor</li>
          <li><i>4</i>Q&A</li>
          <li><i>5</i>Discussion regarding next steps and additional documents to be exchanged.</li>
        </ul>
      </div>
    </div>
    <div class="pta-meeting-right">
      <div style="background:#ffffff;padding:30px;margin-bottom:30px;border-radius:10px;">
        <h3 style="font-weight:600;margin-bottom:30px;">Topics Discussed</h3>
        <div class="pta-meeting-topics" v-if="transcript.topics && transcript.topics.length">
          <div v-for="(topic, index) in topics_array" v-if="topics_array_values[index]['number']">
              <h5 style="font-size:19px;line-height:24px;font-weight:500;"><span style="color:#029165;display:inline-block;margin-right:10px;font-size:13px;background:#9DF6E4;line-height:14px;padding:5px 10px;position:relative;top:-2px;">{{ topics_array_values[index]["number"] }}</span>{{ topics_array_values[index]["title"] }}</h5>
              <p>{{ topics_array_values[index]["summary"] }}</p>
          </div>
        </div>
      </div>
      <div style="background:#ffffff;padding:30px;margin-bottom:30px;border-radius:10px;">
        <h3 style="font-weight:600;">General Summary of the Meeting</h3>
        <div style="font-size:16px;line-height:22px;" v-html="typeValue"></div>
      </div>
      <div style="background:#ffffff;padding:30px;margin-bottom:30px;border-radius:10px;">
        <h3 style="font-weight:600;">Content</h3>
        <div style="font-size:16px;line-height:22px;" v-html="transcript.content.replace(/(?:\r\n|\r|\n)/g, '<br>')"></div>
      </div>
    </div>
    <div style="clear:left;"></div>
  </div>
</div>
</template>
<script>
export default {
  components : {  },
  data() {
    return {
      alias:this.$route.params.alias,
      investors: {
        total: 0,
        data: []
      },
      filterInvestorForm: {
        name: '',
        contact_person: '',
        sort_by : 'name',
        order: 'asc',
        page_length: 100
      },
      transcriptForm: new Form({
        esg: '',
        fund_first_time: '',
        holding_period: '',
        ticket_size: '',
        preferred_fund_type: '',
        preferred_geography: ''
      },false),
      investorForm: new Form({
        esg: '',
        fund_first_time: '',
        holding_period: '',
        ticket_size: '',
        preferred_fund_type: '',
        preferred_geography: '',
        active: '',
        description: '',
        policy_description: '',
        limited_partner_type_organization: '',
        investment_structure: '',
        open_to_first_time_funds: '',
        preferred_commitment_size: '',
        commitments: '',
        commitments_in_re_funds: '',
        commitments_in_vc_funds: '',
        commitments_in_infrastructure: '',
        commitments_in_pe_funds: '',
        alternative_investments_perc: '',
        real_estate_perc: '',
        private_equity_perc: '',
        alternative_investments_amn: '',
        real_estate_amn: '',
        private_equity_amn: '',
        number_of_employees: '',
        irr_perc: '',
        moic: '',
        preferred_fund_type_organization: '',
        fund_status: '',
        esg_status: '',
        assets_under_management: '',
      },false),
      fund_categories: '',
      fund_types: [],
      continents: '',
      countries : [],
      currencies: [],
      transcript: '',
      investor: '',
      showInvestorSave: false,
      selected_preferred_fund_type_organization: [],
      is_loaded: false,
      typeValue: "",
      typeStatus: false,
      typingSpeed: 30,
      charIndex: 0,
      topicsValue: '<div><h5 style="font-size:19px;line-height:24px;font-weight:500;"><span style="color:#029165;display:inline-block;margin-right:10px;font-size:13px;background:#9DF6E4;line-height:14px;padding:5px 10px;position:relative;top:-2px;">',
      topics: "",
      topics_index: 0,
      charTopicsIndex: 0,
      topics_array: [],
      topics_array_values: [],
      topics_array_values_run: [],
      topics_run_index: 0,
      run_index_type: 0
    };
  },
  mounted(){
   /* if(!helper.hasPermission('edit-user')){
      helper.notAccessibleMsg();
      this.$router.push('/account/transcripts');
    }
this.prerequisite();
     */

    this.fetchTranscriptData();
  },
  methods: {
    unserialize(data){
      // Takes a string representation of variable and recreates it
      //
      // version: 810.114
      // discuss at: http://phpjs.org/functions/unserialize
      // +     original by: Arpad Ray (mailto:arpad@php.net)
      // +     improved by: Pedro Tainha (http://www.pedrotainha.com)
      // +     bugfixed by: dptr1988
      // +      revised by: d3x
      // +     improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
      // %            note: We feel the main purpose of this function should be to ease the transport of data between php & js
      // %            note: Aiming for PHP-compatibility, we have to translate objects to arrays
      // *       example 1: unserialize('a:3:{i:0;s:5:"Kevin";i:1;s:3:"van";i:2;s:9:"Zonneveld";}');
      // *       returns 1: ['Kevin', 'van', 'Zonneveld']
      // *       example 2: unserialize('a:3:{s:9:"firstName";s:5:"Kevin";s:7:"midName";s:3:"van";s:7:"surName";s:9:"Zonneveld";}');
      // *       returns 2: {firstName: 'Kevin', midName: 'van', surName: 'Zonneveld'}

      var error = function (type, msg, filename, line){throw new window[type](msg, filename, line);};
      var read_until = function (data, offset, stopchr){
        var buf = [];
        var chr = data.slice(offset, offset + 1);
        var i = 2;
        while(chr != stopchr){
          if((i+offset) > data.length){
            error('Error', 'Invalid');
          }
          buf.push(chr);
          chr = data.slice(offset + (i - 1),offset + i);
          i += 1;
        }
        return [buf.length, buf.join('')];
      };
      var read_chrs = function (data, offset, length){
        buf = [];
        for(var i = 0;i < length;i++){
          var chr = data.slice(offset + (i - 1),offset + i);
          buf.push(chr);
        }
        return [buf.length, buf.join('')];
      };
      var _unserialize = function (data, offset){
        if(!offset) offset = 0;
        var buf = [];
        var dtype = (data.slice(offset, offset + 1)).toLowerCase();

        var dataoffset = offset + 2;
        var typeconvert = new Function('x', 'return x');
        var chrs = 0;
        var datalength = 0;

        switch(dtype){
          case "i":
            typeconvert = new Function('x', 'return parseInt(x)');
            var readData = read_until(data, dataoffset, ';');
            var chrs = readData[0];
            var readdata = readData[1];
            dataoffset += chrs + 1;
            break;
          case "b":
            typeconvert = new Function('x', 'return (parseInt(x) == 1)');
            var readData = read_until(data, dataoffset, ';');
            var chrs = readData[0];
            var readdata = readData[1];
            dataoffset += chrs + 1;
            break;
          case "d":
            typeconvert = new Function('x', 'return parseFloat(x)');
            var readData = read_until(data, dataoffset, ';');
            var chrs = readData[0];
            var readdata = readData[1];
            dataoffset += chrs + 1;
            break;
          case "n":
            readdata = null;
            break;
          case "s":
            var ccount = read_until(data, dataoffset, ':');
            var chrs = ccount[0];
            var stringlength = ccount[1];
            dataoffset += chrs + 2;

            var readData = read_chrs(data, dataoffset+1, parseInt(stringlength));
            var chrs = readData[0];
            var readdata = readData[1];
            dataoffset += chrs + 2;
            if(chrs != parseInt(stringlength) && chrs != readdata.length){
              error('SyntaxError', 'String length mismatch');
            }
            break;
          case "a":
            var readdata = {};

            var keyandchrs = read_until(data, dataoffset, ':');
            var chrs = keyandchrs[0];
            var keys = keyandchrs[1];
            dataoffset += chrs + 2;

            for(var i = 0;i < parseInt(keys);i++){
              var kprops = _unserialize(data, dataoffset);
              var kchrs = kprops[1];
              var key = kprops[2];
              dataoffset += kchrs;

              var vprops = _unserialize(data, dataoffset);
              var vchrs = vprops[1];
              var value = vprops[2];
              dataoffset += vchrs;

              readdata[key] = value;
            }

            dataoffset += 1;
            break;
          default:
            error('SyntaxError', 'Unknown / Unhandled data type(s): ' + dtype);
            break;
        }
        return [dtype, dataoffset - offset, typeconvert(readdata)];
      };
      return _unserialize(data, 0)[2];
    },

    fetchTranscriptData(){
      axios.get('/api/transcript-by-alias/'+this.alias)
          .then(response => response.data)
          .then(response => {
            this.transcript = response;
            this.transcript.summary = this.transcript.summary.replace(/(?:\r\n|\r|\n)/g, '<br>');

            this.transcriptForm.esg = this.transcript.esg;
            this.transcriptForm.fund_first_time = this.transcript.fund_first_time;
            this.transcriptForm.holding_period = Math.round((this.transcript.holding_period_from + this.transcript.holding_period_from) / 2);
            this.transcriptForm.ticket_size = this.transcript.ticket_size;
            this.transcriptForm.preferred_fund_type = this.transcript.preferred_fund_type;
            this.transcriptForm.preferred_geography = this.transcript.preferred_geography;
            this.transcriptForm.content = this.transcript.content;

            this.transcript.topics.forEach((topic) => {

              this.topics_array[this.topics_index] = [];
              this.topics_array[this.topics_index]["number"] =  'TOPIC '+ (this.topics_index+1);
              this.topics_array[this.topics_index]["title"] =  topic.title;
              this.topics_array[this.topics_index]["summary"] =  topic.summary;

              this.topics_array_values[this.topics_index] = [];
              this.topics_array_values[this.topics_index]["number"] =  '';
              this.topics_array_values[this.topics_index]["title"] =  '';
              this.topics_array_values[this.topics_index]["summary"] =  '';

              this.topics_array_values_run[this.topics_run_index] = [];
              this.topics_array_values_run[this.topics_run_index]["index"] = this.topics_index;
              this.topics_array_values_run[this.topics_run_index]["name"] = "number";
              this.topics_array_values_run[this.topics_run_index]["text"] = 'TOPIC '+ (this.topics_index+1);
              this.topics_run_index++;
              this.topics_array_values_run[this.topics_run_index] = [];
              this.topics_array_values_run[this.topics_run_index]["index"] = this.topics_index;
              this.topics_array_values_run[this.topics_run_index]["name"] = "title";
              this.topics_array_values_run[this.topics_run_index]["text"] = topic.title;
              this.topics_run_index++;
              this.topics_array_values_run[this.topics_run_index] = [];
              this.topics_array_values_run[this.topics_run_index]["index"] = this.topics_index;
              this.topics_array_values_run[this.topics_run_index]["name"] = "summary";
              this.topics_array_values_run[this.topics_run_index]["text"] = topic.summary;
              this.topics_run_index++;

              this.topics_index++;

            }, this);

           this.typeTopics(0);

            if(this.transcript.investor_id){
              this.investor = this.transcript.investor;

              if(this.investor.preferred_fund_type_organization) {
                let preferred_fund_type_organization_temp = this.investor.preferred_fund_type_organization.split(",");

                preferred_fund_type_organization_temp.forEach((element) => {
                  console.log(element);
                  this.selected_preferred_fund_type_organization.push({ id: element, name:'test'});
                }, this);
                console.log(this.selected_preferred_fund_type_organization[0].id);
              }

              // let investor_types = this.unserialize(this.transcript.investor.investor_types);
              // let preferred_geography = this.unserialize(this.transcript.investor.geos);
              let investor_types_output = "";
              let preferred_geography_output = "";

              this.investor.preferred_fund_type = investor_types_output;
              this.investor.preferred_geography = preferred_geography_output;
            }

            this.is_loaded = true;
          })
          .catch(error => {
            helper.showDataErrorMsg(error);
            this.$router.push('/transcript');
          })
    },
    typeTopics() {
      console.log(this.run_index_type);
      if(this.run_index_type < this.topics_array_values_run.length) {
        if (this.charIndex < this.topics_array_values_run[this.run_index_type]["text"].length) {
          this.topics_array_values[this.topics_array_values_run[this.run_index_type]["index"]][this.topics_array_values_run[this.run_index_type]["name"]] += this.topics_array_values_run[this.run_index_type]["text"].charAt(
              this.charIndex
          );
          this.charIndex += 1;
          console.log(this.topics_array_values_run[this.run_index_type]["index"]);
          console.log(this.topics_array_values_run[this.run_index_type]["name"]);
          console.log(this.topics_array_values_run[this.run_index_type]["text"].charAt(this.charIndex));
          if(this.charIndex<4){
            setTimeout(this.typeTopics, this.typingSpeed);
          }
        } else {
          this.charIndex = 0;
          this.run_index_type += 1;
          setTimeout(this.typeTopics, this.typingSpeed);
        }

      }
    },
    prerequisite(){
      axios.get('/api/user/profile/questionnaire/pre-requisite')
          .then(response => response.data)
          .then(response => {
            this.fund_categories  = response.fund_categories;
            this.fund_types       = response.fund_types;
            this.continents       = response.continents;
            this.countries        = response.countries;
            this.currencies       = response.currencies;


          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    /*  submit(){
        this.transcriptForm.date_of_birth = (this.transcriptForm.date_of_birth) ? moment(this.transcriptForm.date_of_birth).format('YYYY-MM-DD') : null;
        this.transcriptForm.date_of_anniversary = (this.transcriptForm.date_of_anniversary) ? moment(this.transcriptForm.date_of_anniversary).format('YYYY-MM-DD') : null;
        this.transcriptForm.patch('/api/transcript/'+this.id)
            .then(response => {
                this.fetchTranscriptData();
                toastr.success(response.message);
            })
            .catch(error => {
                helper.showErrorMsg(error);
            });
    }, */
  },

  filters: {
    moment(date) {
      return helper.formatDate(date);
    },
    momentDateTime(date) {
      /* return helper.formatDateTime(date).replace(" "," at "); */
      if(!date)
        return;

      var date_format = "DD.MM.YYYY";
      var time_format = "H:mm";

      return moment(date).format(date_format+' '+time_format).replace(" "," at ");
    }
  }
}
</script>
<style>
.pta-transcript-participant:after{
  content: ', ';
}
.pta-transcript-participant:last-child:after{
  content: '';
}.pta-meeting-agenda{
   list-style: none;
   margin:0;
   padding:0;
 }
.pta-meeting-agenda li {
  font-size: 16px;
  line-height: 22px;
  padding-left:36px;
  position:relative;
  margin-bottom:15px;
}
.pta-meeting-agenda li i{
  position:absolute;
  left:0;
  top:-1px;
  line-height:24px;
  background:#34A7C2;
  border-radius:24px;
  width:24px;
  height:24px;
  color:#fff;
  text-align:center;
  font-style: normal;
  font-size: 14px;
}
.pta-meeting-topics > div{
  font-size:14px;margin-bottom:40px;border-bottom:1px solid #ccc;padding-bottom:20px;
}
.pta-meeting-topics > div:last-child{
  margin-bottom:0px;border-bottom:0px solid #ccc;padding-bottom:0px;
}
.pta-meeting-left{
  float:left;width:400px;margin-right:30px;
}
.pta-meeting-right{
  float:left;width:calc(100% - 430px);
}
.pta-meeting-head{
  text-align:center;margin-bottom:40px;
}
.pta-meeting-head h2{
  color:#1C2136;font-size:40px;line-height:48px;font-weight:600;
}
.pta-meeting-head p{
  color:#848181
}

@media (max-width: 980px) {
  .pta-meeting-left,.pta-meeting-right{
    float:none;width:100%;
    margin-bottom:20px;
  }
  .pta-meeting-head{
    text-align:left;
    margin-bottom:20px;
  }
}

@media (max-width: 480px) {
  .pta-meeting-head h2{
    font-size:30px;
    line-height:36px;
  }
  .pta-meeting-head p{
    font-size:18px;
    line-height:24px;
  }
  .pta-meeting-head .mm-links{
    float:none;
    margin:0;
    padding:0;
  }
  .pta-meeting-head .mm-links li:first-child{
    margin-left: 0px;
  }
}

</style>